.me-logo {
  display: inline-flex;

  img {
    display: block;
    width: 100%;
    max-height: 36px;

    @include desktop {
      max-height: 40px;
    }
  }

  // Pages authored before `me-logo` gained width/height still ship an <img> with no dimensions,
  // so its box is 0x0 until the file lands and the logo jumps into place. Reserve it from the
  // capped height plus a wordmark-ish default ratio — `auto` in front of the ratio means the
  // real intrinsic one takes over the moment the image decodes, so only the pre-load box is a
  // guess. Measured on production: 0x0 -> 106x36 becomes 108x36 -> 106x36.
  // Scoped to images without the attributes, so usages that pass them are untouched.
  img:not([width]) {
    width: auto;
    height: 36px;
    aspect-ratio: auto 3 / 1;
    object-fit: contain;

    @include desktop {
      height: 40px;
    }
  }

  &--text {
    font-weight: bold;
    text-decoration: none;
  }
}
